import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { displayMessage } from '../../services/helper';
import React, { useState } from 'react';
import { Button } from 'antd';


export default function SectionGrid({ section, index, maxGridCounts}) {
    const [isOpen, setIsOpen] = useState(false)
    const maxGridCountsRef = maxGridCounts || 4 
    const myDuration = () => {
        let duration = displayMessage('NOT_INFORMED2')
        let inicial_duration = parseFloat(section?.block_time_current)
        if (section) {
            let duration_mins = section?.block_time_current ? Math.floor(inicial_duration) : 0
            let duration_sec = section?.block_time_current ? ((inicial_duration - duration_mins) * 60).toFixed(0) : 0
            if (parseInt(duration_mins) > 0 || parseInt(duration_sec) > 0) {
                duration = `${duration_mins > 0 ? `${duration_mins}min ` : ''}${duration_sec > 0 ? `${duration_sec}s` : ''}`
            }
        }
        return duration
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: index < maxGridCountsRef ? '#1B3663' : '#5c5c5c', width: '100%', height: 30 }}>
                <div style={{ width: '15%' }} />
                <div style={{ display: 'flex', flex: 1, color: 'white', alignItems: 'center', justifyContent: 'center' }}>{displayMessage('SECTION', [index ? index : ''])}</div>
                <div style={{ width: '10%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginRight: '5%' }}>
                    <Button
                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}
                        shape='circle'
                        onClick={() => setIsOpen(!isOpen)}
                        size='small'
                        icon={isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
                    />
                </div>
            </div>
            {
                isOpen == true &&
                <div style={{ display: 'flex', flexDirection: 'row', fontSize: 12, flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>{displayMessage('OPEN_LIP')}</div>
                        <div>{section?.open_lip}</div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>
                            {displayMessage('CAMERA')}
                        </div>
                        <div>{section?.camera_off}</div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>{displayMessage('MONITORY')} ⭐</div>
                        <div>{section?.is_completed == true ? section?.stars : displayMessage('NOT_INFORMED2')}</div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>{displayMessage('MANGOS')}</div>
                        <div>{section?.is_completed == true ? section?.mangos : displayMessage('NOT_INFORMED2')}</div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', border: '1px solid lightgray', padding: 4, minWidth: 100, }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}>{displayMessage('DURATION')}</div>
                        <div>{myDuration()}</div>
                    </div>

                </div>
            }
        </div>
    )
}

